module.exports = __webpack_public_path__ + "media/assets/icons/openmoji_thought-balloon-1622ba87d8c946a707db849e5d2e4218.svg";